const Consts = {
    api_url: 'back.igra-hotelka.ru'
}

export default Consts